/* eslint-disable react/function-component-definition */
import React, { useEffect } from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import styles from './index.module.scss';
import { REACT_APP_API_FETCH_VENDOR } from '../../redux/apiConstants';
import VendorCustomTable from '../../components/VendorCustomTable/CustomTable';

const VendorIndex = React.memo(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.indexdiv}>
      <VendorCustomTable
        urlParam={REACT_APP_API_FETCH_VENDOR}
        section="vendor"
        dashTitle="Vendors"
        toggleButton={{ show: true, field: 'active' }}
        deleteCondition={{ checkCondition: false, apiUrl: 'www.google.com' }}
      />
    </div>
  );
});
export default VendorIndex;
